export default function removeTable(editor, tableId) {
  var table = editor.getTable(tableId);
  return editor.moveToStartOfNode(table).moveToEndOfPreviousText().removeNodeByKey(table.key);
}